<template>
  <div
    v-loading="loading"
    class="l-page l-page--search"
  >
    <div class="l-page__header c-page__header">
      <h2
        v-menu-title
        class="c-page__header-title"
      >
        项目维保计划
      </h2>
      <div class="c-page__header-btns">
        <k-button
          type="primary"
          icon="kestrel-icon ki-search"
          btn-text="查询"
          @click="refreshSearch"
        />
        <k-button
          icon="kestrel-icon ki-repeat"
          btn-text="重置"
          @click="resetForm"
        />
        <k-button
          v-if="isProjectManager"
          type="success"
          icon="kestrel-icon ki-plus"
          btn-text="新增"
          :auth-type="false"
          @click="openCreateDialog"
        />
      </div>
    </div>
    <div class="l-page__item l-page--search__item">
      <hm-page-card
        title="查询条件"
        class="c-card--condition"
      >
        <el-form
          ref="filterParams"
          class="c-form c-condition__form"
          :model="filterParams"
          :inline="true"
          label-position="right"
          label-width="80px"
          label-suffix="："
        >
          <el-row class="c-form__row">
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="计划名称"
              >
                <el-input
                  v-model.trim="filterParams.jhmc"
                  class="c-form__input"
                  placeholder="请输入计划名称"
                  clearable
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </hm-page-card>
    </div>
    <div class="l-page__body l-page--search__body">
      <el-tabs
        type="border-card"
        class="l-page__tabs l-page__tabs--single"
      >
        <el-tab-pane label="查询结果">
          <k-table
            ref="kTable"
            height="100%"
            :table-column="tableColumn"
            :data="page.rows"
            :pagination="page"
            @current-change="search"
            @size-change="handleSizeChange"
          >
            <template #jhmc="scope">
              <el-link
                type="primary"
                @click="openPlanDetail(scope.row)"
              >
                {{ scope.row.jhmc }}
              </el-link>
            </template>
            <template #createTime="scope">
              {{ formatDateTime(scope.row.createTime) }}
            </template>
            <template #operation="scope">
              <k-button
                v-if="isProjectManager && scope.row.jhzt === 'WKS'"
                type="primary"
                plain
                btn-text="编辑"
                :auth-type="false"
                @click="editPlan(scope.row)"
              />
              <k-button
                v-if="isProjectManager && scope.row.jhzt === 'WKS'"
                type="danger"
                plain
                btn-text="删除"
                :auth-type="false"
                @click="deletePlan(scope.row)"
              />
            </template>
          </k-table>
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-dialog
      :title="editingPlanId ? '修改维保计划' : '新增维保计划'"
      :visible.sync="createDialogVisible"
      width="900px"
      custom-class="jxxf-plan-dialog"
      append-to-body
      :close-on-click-modal="false"
      @closed="handleDialogClosed"
    >
      <jxxf-wb-plan-form
        v-if="createDialogVisible"
        ref="planForm"
        dialog-mode
        :project-id="xmId"
        :plan-id="editingPlanId"
        @saved="handlePlanSaved"
      />
      <div
        slot="footer"
        class="o-dialog__footer"
      >
        <k-button
          type="primary"
          icon="kestrel-icon ki-save"
          btn-text="保存"
          :auth-type="false"
          @click="saveCreatePlan"
        />
        <k-button
          icon="kestrel-icon ki-close"
          btn-text="取消"
          :auth-type="false"
          @click="createDialogVisible = false"
        />
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { planService } from './plan.service';
import JxxfWbPlanForm from './planDialog.vue';

export default {
  name: 'JxxfWbProjectPlanList',
  components: { JxxfWbPlanForm },
  data () {
    return {
      loading: false,
      createDialogVisible: false,
      editingPlanId: '',
      isProjectManager: false,
      xmId: this.$route.params.xmId,
      filterParams: { jhmc: null },
      trueFilterParams: {},
      page: { rows: [], total: 0, pageSize: 15, pageNo: 0 },
      tableColumn: [
        { key: 'index', label: '序号', align: 'center', width: this.$commonConfig.tableWidthConfig.common_xh, type: 'index' },
        { key: 'xmmc', label: '项目名称', align: 'left', minWidth: '160', type: 'text' },
        { key: 'jhmc', slotName: 'jhmc', label: '计划名称', align: 'left', minWidth: '180', type: 'text' },
        { key: 'jhsjQ', label: '计划开始时间', align: 'center', minWidth: '110', type: 'date' },
        { key: 'jhsjZ', label: '计划结束时间', align: 'center', minWidth: '110', type: 'date' },
        { key: 'jhztMc', label: '计划状态', align: 'center', minWidth: '100', type: 'text' },
        { key: 'createTime', slotName: 'createTime', label: '创建时间', align: 'center', minWidth: '155', type: 'text' },
        { key: 'operation', slotName: 'operation', label: '操作', align: 'center', minWidth: '150', type: 'text' }
      ]
    };
  },
  methods: {
    /** 保存查询条件并从第一页加载当前项目计划。 */
    refreshSearch () {
      this.trueFilterParams = JSON.parse(JSON.stringify(this.filterParams));
      this.search(1);
    },
    /** 使用当前分页参数加载当前项目的计划。 */
    search (pageNo = 1) {
      this.loading = true;
      planService.page(Object.assign({}, this.trueFilterParams, { xmId: this.xmId, pageNo, pageSize: this.page.pageSize })).then(rsp => {
        this.page = Object.assign({}, this.page, rsp.data);
      }).finally(() => {
        this.loading = false;
      });
    },
    /** 使用统一表格组件的页大小重新查询。 */
    handleSizeChange (pageSize) {
      this.page.pageSize = pageSize;
      this.search(1);
    },
    /** 清空当前项目计划查询条件。 */
    resetForm () {
      this.$refs.filterParams.resetFields();
    },
    /** 格式化后端返回的秒级或毫秒级创建时间。 */
    formatDateTime (value) {
      if (value === null || value === undefined || value === '') return '-';
      const raw = Number(value);
      const date = Number.isFinite(raw)
        ? new Date(raw < 100000000000 ? raw * 1000 : raw)
        : new Date(String(value).replace(/-/g, '/'));
      if (Number.isNaN(date.getTime())) return '-';
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hour = String(date.getHours()).padStart(2, '0');
      const minute = String(date.getMinutes()).padStart(2, '0');
      const second = String(date.getSeconds()).padStart(2, '0');
      return date.getFullYear() + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second;
    },
    /** 打开当前维保计划的查看页面。 */
    openPlanDetail (row) {
      this.openNavTab({ name: 'jxxfWbPlanDetail', params: { id: row.uuid } });
    },
    /** 打开当前项目的新增计划弹窗。 */
    openCreateDialog () {
      this.editingPlanId = '';
      this.createDialogVisible = true;
    },
    /** 调用新增计划弹窗内表单的保存方法。 */
    saveCreatePlan () {
      this.$refs.planForm.save();
    },
    /** 新增计划成功后关闭弹窗并刷新列表。 */
    handlePlanSaved () {
      this.createDialogVisible = false;
      this.search(1);
    },
    /** 弹窗关闭后清理显示状态。 */
    handleDialogClosed () {
      this.createDialogVisible = false;
      this.editingPlanId = '';
    },
    /** 打开未开始计划的编辑弹窗。 */
    editPlan (row) {
      if (row.jhzt !== 'WKS') {
        this.$message.warning('仅未开始的维保计划可以修改');
        return;
      }
      this.editingPlanId = row.uuid;
      this.createDialogVisible = true;
    },
    /** 删除未开始的计划并刷新当前项目列表。 */
    deletePlan (row) {
      this.$confirm('确认删除维保计划“' + row.jhmc + '”吗？', '提示', { type: 'warning' }).then(() => {
        return planService.remove(row.uuid);
      }).then(() => {
        this.$message.success('删除成功');
        this.search(1);
      }).catch(() => {});
    }
  },
  created () {
    this.isProjectManager = ((this.$HMStoreService.getUserinfo() || {}).roles || []).includes('JX-XMGLY');
    this.refreshSearch();
  }
};
</script>
<style lang="scss">
.jxxf-plan-dialog {
  .el-dialog__body { padding: 10px 20px 20px; }
  .l-page { min-height: 0; }
  .l-page__body { padding: 0; }
}
</style>
